import { customEvent, getCookie, cooKeys } from "goi_common";
import { 장례준비긴급도_LIST_EVENT_KEY } from "@/containers/MatchContainer/constants/request";
import {
  SessionLandingType,
  랜딩페이지_LIST_EVENT_KEY,
  랜딩페이지_LIST_EVENT_KEYS,
} from "@/constants/landingType";

/**
 * 비회원 견적 제출 시 공통 이벤트 발화
 * - guest_submit_${임박도}: 장례준비긴급도별
 * - guest_search_needs: 검색광고 유입
 * - guest_landing_${랜딩타입}: 랜딩페이지별
 *
 * @param bodyStatus - body.status (유저가 폼에서 선택한 장례준비긴급도). 없으면 cookie에서 fallback
 */
export function fireGuestSubmitEvents(bodyStatus?: string) {
  // 이 함수는 견적 제출 POST 성공 뒤에 불린다. 이벤트 실패가 호출부 catch 로 번지면
  // 뒤따르는 쿠키 저장·/login 이동이 통째로 날아간다. fireLeadSubmitEvents 와 같은 이유.
  try {
    /**
     * 광고 전환가치용 퍼널 완주 이벤트.
     * 이 함수는 견적 제출부에서만 호출되므로 장지추천 제출은 자동으로 빠진다.
     */
    customEvent({ newGtm: { action: "goi_funnel_complete" } });

    /** 비회원 견적 이벤트 전송 - 임박도별 */
    const submitStatus = getCookie(cooKeys.quotation_request)?.status || bodyStatus;

    if (submitStatus) {
      const statusEventKey = 장례준비긴급도_LIST_EVENT_KEY[submitStatus];
      customEvent({
        newGtm: {
          action: `guest_submit_${statusEventKey}`,
        },
      });
    }

    /** 비회원 견적 추가 필요 - 채널별 */
    const isSearchAd = getCookie(cooKeys.is_search_ad);

    if (isSearchAd) {
      customEvent({
        newGtm: {
          action: "guest_search_needs",
        },
      });
    }

    /** 비회원 견적 이벤트 - 페이지별 */
    const sessionLandingType = getCookie(cooKeys.session_landing_type);

    if (sessionLandingType && 랜딩페이지_LIST_EVENT_KEYS.includes(sessionLandingType)) {
      customEvent({
        newGtm: {
          action: `guest_landing_${
            랜딩페이지_LIST_EVENT_KEY[sessionLandingType as SessionLandingType]
          }`,
        },
      });
    }
  } catch (e) {
    console.error("guest_submit 이벤트 발화 실패:", e);
  }
}
